export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 1.42,
        "transcript": "Arnassagaurrniluku.",
        "translation": "Saying she became an old woman."
    },
    "2": {
        "startTime": 1.8599999999999999,
        "endTime": 8.06,
        "transcript": "Ellminek-gguq tarritellria angukara'urlurmek arnassagarmek-llu aciyuitaat.",
        "translation": "They say that they don't call those who walk by themselves old men and women."
    },
    "3": {
        "startTime": 8.29,
        "endTime": 14.93,
        "transcript": "Tau͡gaam angutngurtellriamek wall'u arnaurtellriamek-llu aterpagtelaraat.",
        "translation": "Instead, they call them older men and women."
    },
    "4": {
        "startTime": 15.225,
        "endTime": 22.825,
        "transcript": "Makut qanruyutait ciuliamta wangkuta qemagngangaicaaqaput elisngastaitni",
        "translation": "We who know about our ancestors' traditional wisdom will not hold them back"
    },
    "5": {
        "startTime": 22.87,
        "endTime": 28.18,
        "transcript": "Akaarnun nunami maani nangengqatnguata.",
        "translation": "Because they live long lives on this earth."
    },
    "6": {
        "startTime": 29.23,
        "endTime": 34.1,
        "transcript": "Kenkek'ngaput-qaa tuquyararaasqaput wangkuta yup'ut?",
        "translation": "Do wish early deaths upon our people whom we love?"
    },
    "7": {
        "startTime": 34.35,
        "endTime": 41.42,
        "transcript": "Kenkekumteki makunek ciuliamta alerquutaitnek arcaqerluki qanrutarkaugaput.",
        "translation": "If we love them, we must especially tell them about our ancestors traditional instructions."
    },
    "8": {
        "startTime": 41.774,
        "endTime": 55.887,
        "transcript": "Tuamta-llu wangkuta Yugni alerquutengqertukut yuullgutput tamalkuita elluarrluki ciuniuresqelluki allakaukevkenaki ilakuyulluta.",
        "translation": "And then, we Yupiit have instructions to wholeheartedly welcome our fellow peoples without discriminating against them, but in accordance with them."
    },
    "9": {
        "startTime": 56.349,
        "endTime": 66.024,
        "transcript": "Kitumek, kinkut imkut Alaska-m yui tuaten umyuallgutekluteng ilakuyulluki nangengqasqumaut.",
        "translation": "Everyone in Alaska is asked to stand with one mind with each other."
    },
    "10": {
        "startTime": 66.905,
        "endTime": 79.443,
        "transcript": "Mat'um ilii, mat'um-am agayumacim ilait waten qanertut: \"Wangkuta agayumacirput assirtuq tukniluni-llu.\"",
        "translation": "Some people say this about part of our beliefs: \"Our traditionals beliefs are good and powerful.\""
    },
    "11": {
        "startTime": 79.631,
        "endTime": 84.131,
        "transcript": "Tuaten pinrituq. Tuaten ayuqenrituq.",
        "translation": "That's not the case. That's now how it is."
    },
    "12": {
        "startTime": 84.4,
        "endTime": 91.738,
        "transcript": "Ciuliamta ilakuyutiit navyunaicaaqerput wangkuta, piunriyunaunaku-llu.",
        "translation": "We should not destroy our ancestors' sense of community and should not get rid of it."
    },
    "13": {
        "startTime": 91.988,
        "endTime": 99.513,
        "transcript": "Una ilakuyun avaken ayagluni ciuliamta qanrutkaat kenkauguq.",
        "translation": "Our ancestors say that our ancient sense of community is a form of love."
    },
    "14": {
        "startTime": 100.044,
        "endTime": 109.207,
        "transcript": "Kenka atunrilkumteggu maani unguvallemteńi qaill' piluta anirtuumaciqceta? Allamek anirtuutaitukut.",
        "translation": "If we do not practice love in our lives here, how will we be saved? We have no other salvation."
    },
    "15": {
        "startTime": 109.369,
        "endTime": 115.369,
        "transcript": "Ciuliamta kena atullruat, anirtuumaluteng-llu ayaumaluteng",
        "translation": "Our ancestors practiced live, and they were saved as they continued"
    },
    "16": {
        "startTime": 115.413,
        "endTime": 121.676,
        "transcript": "Tamana atullruamegteggu yuullgutmeggnun tamalkuitnun allakuakutevkenateng.",
        "translation": "Because they practiced that with all of their fellow people without discrimination."
    },
    "17": {
        "startTime": 122.051,
        "endTime": 132.151,
        "transcript": "Agayumacit ayuqenrilnguut allakaukucetaangraitkut tamana allakaukucaraq assiituq, uitacurlagnaqluni-llu.",
        "translation": "Even if various other religions try to divide us, discrimination is bad, and leads to unrest."
    },
    "18": {
        "startTime": 132.545,
        "endTime": 144.333,
        "transcript": "Ciuliamta tau͡gaam alerquutiit ilakuyucaraq atuqumteggu nutaan uitangqegciluta nangengqaciqukut, ukverput-llu qaqimalriaruluni",
        "translation": "But if we use our ancestors sense of community, we will live in peace, and our faith will be complete"
    },
    "19": {
        "startTime": 144.521,
        "endTime": 148.258,
        "transcript": "Tamaaggun-llu kenkekun anirtuumaarkauluta.",
        "translation": "And we will be saved through that love."
    },
    "20": {
        "startTime": 148.471,
        "endTime": 160.808,
        "transcript": "Makut maa-i wangkuta makunun kinguliaramteńun arcaqerluku elisngavkararkauyaaqerput, mat'um-llu nunamta assirluku auluklerkaa.",
        "translation": "We must make our descendants especially be knowledgable about these, including how to take care of our land."
    },
    "21": {
        "startTime": 161.633,
        "endTime": 168.621,
        "transcript": "Makut qanruyutet wangkuta nallunritestaini iirumatuvkenaki.",
        "translation": "We who know the traditional wisdom should not hide them."
    },
    "22": {
        "startTime": 169.171,
        "endTime": 172.721,
        "transcript": "Waten-gguq tang ciuliaput ayuqellrulriit:",
        "translation": "You see, they said that our ancestors were like this:"
    },
    "23": {
        "startTime": 173.44,
        "endTime": 185.128,
        "transcript": "Qasgimi-gguq ayagyuaq tupagyarturnaurtuq ak'a tan'gerem iluani angukara'urluq qallaqurallinilria yuum elluarrluni yuullerkaanek.",
        "translation": "They said that a young boy would wake up in the community house in the dark to an old man already speaking about how a person should live life right."
    },
    "24": {
        "startTime": 185.253,
        "endTime": 199.753,
        "transcript": "Ayuqluku enemi-lu qakmani arnassagaq-gguq ak'a qallatellallinilria tan'gerem iluani ukut kenkek'ngani qaneryaramun ayuqucirtuutmun-llu tupagtelluki.",
        "translation": "In the same way out in the houses, they said that an old woman would be speaking in the dark so that those she loved would wake up to traditional wisdom and teachings."
    },
    "25": {
        "startTime": 199.897,
        "endTime": 205.472,
        "transcript": "Tuatnalartukut-qaa? Tuatnaksaitukut.",
        "translation": "Do we do that? We haven't done that."
    },
    "26": {
        "startTime": 206.778,
        "endTime": 214.028,
        "transcript": "Tamana ciuliamta ayuqucillrat wangkuta nangrutarkauyaaqaput makunun kinguliaramteńun.",
        "translation": "We should bring up what our ancestors were like to our descendants."
    },
    "27": {
        "startTime": 214.247,
        "endTime": 220.685,
        "transcript": "Allakun anirtuutaitukut. Ilakuyutekun tau͡gaam anirtuutengqertukut.",
        "translation": "We have no other salvation. We only have salvation through community."
    },
    "28": {
        "startTime": 221.285,
        "endTime": 228.735,
        "transcript": "Atrallruuq Jesus-aaq ilakuyun tau͡gaam qaqicarturluku nunam qainganun tamiini.",
        "translation": "Jesus came down only to complete community to everywhere on earth."
    },
    "29": {
        "startTime": 229.192,
        "endTime": 244.704,
        "transcript": "Man'a nallunrilkilaut: tamatum-llu ilakuyutellemta nutaan elluarrluta yuullerkamteńek, pinillerkamteńek, unguvamallerkamteńek ayuqucirturarkauluta.",
        "translation": "Let us know this: that sense of community will teach us how to live well, be strong, and live long lives."
    },
    "30": {
        "startTime": 244.967,
        "endTime": 250.667,
        "transcript": "Angtuaruuq ciuliamta ilakuyulluteng nangengqallrat.",
        "translation": "It is a great thing how our ancestors stood as a community."
    },
    "31": {
        "startTime": 250.774,
        "endTime": 258.324,
        "transcript": "Taum agayumacit pinruningraitki ukveqevkenaki.",
        "translation": "Even if they say that other religions are superior, do not believe them."
    },
    "32": {
        "startTime": 258.593,
        "endTime": 269.443,
        "transcript": "Agayun atauciq pikanirviituq, angkanirviinani, aciqvaqanirviinani. Nutem eluciqluku elucini.",
        "translation": "The one God has no superior, no one greater, and cannot be despised. He is as he always was."
    },
    "33": {
        "startTime": 269.512,
        "endTime": 280.05,
        "transcript": "Ataucimun agayutmun ukvertukuq Jesus-aamun-llu pikanirviilngurmun, qulvaqanirviinani, piniqanirviinani-llu.",
        "translation": "We believe in one god and to Jesus to whom there is no one greater, no one higher, and no one stronger."
    },
    "34": {
        "startTime": 280.05,
        "endTime": 282.088,
        "transcript": "Elucini eluciqluku.",
        "translation": "He is as he is."
    },
    "35": {
        "startTime": 282.151,
        "endTime": 292.813,
        "transcript": "Tamana pitekluku wangkuta Yugni ilakuyun tau͡gaam ayagniutnaurput arcaqerluku makunun kingunemteńun.",
        "translation": "For that reason, let us Yupiit instate community, especially among our descendants."
    },
    "36": {
        "startTime": 293.101,
        "endTime": 297.339,
        "transcript": "Una ayagyuaq waten ayuquq mat'um nalliini:",
        "translation": "A young person is like this these days:"
    },
    "37": {
        "startTime": 297.989,
        "endTime": 309.877,
        "transcript": "Kass'acetun qaneryaurtaqami umyugaa quyigilartuq elisngalriaruyukluni, amta-llu yuullerkaq nalluku, au͡gna-llu tekitellerkani nalluluku.",
        "translation": "When he learns to speak English, he is proud thinking of himself as knowledgable, yet he does not know how to live, and he does not know what is in store for him."
    },
    "38": {
        "startTime": 310.215,
        "endTime": 326.252,
        "transcript": "Makut maa-i wangkuta makunun ayagyuamteńun paivulluki elisngavkararkauyaaqerput au͡gna ciuliamta yuullra, ilakuyutellrat arcaqerluku.",
        "translation": "Now, we must provide these for our young people so that they will know about our ancestors' lives, especially about their sense of community."
    },
    "39": {
        "startTime": 326.59,
        "endTime": 332.99,
        "transcript": "Waten pitalriamek amllenrilengraan qanqertua. Quyana.",
        "translation": "This is all I'm saying even though it's not a lot. Thank you."
    }
};